module.exports = __webpack_public_path__ + "img/bg_3.47b2634f.png";